export enum Apps {
  Unknown = 0,
  TPMPortal,
  POS,
  Donation,
  Lister,
  AdminPortal,
  CompanyPortal,
  IMS,
  Consignment
}

export enum Status {
  Unknown = 0,
  Draft,
  Active,
  Inactive
}

export enum WarehouseLocationFormatType {
  Unknown = 0,
  ARSB,
  Standard
}

export enum WarehouseNumberingOption {
  Unknown = 0,
  ContinuousSequential,
  RestartPerZone
}

export enum WorklistType {
  Unknown = 0,
  SalesOrder,
  PurchaseOrder,
  Movement,
  TransferOrder,
  InventoryCount,
  TransferReceiveOrder,
  TransferDispatchOrder,
  ReturnOrder,
  Replenishment
}

export enum WorklistStatus {
  Unknown,
  Pending,
  InProgress,
  Completed,
  Cancelled
}

export enum WorklistItemStatus {
  Unknown,
  NotAssigned,
  Assigned,
  InProgress,
  Completed,
  Cancelled
}

export enum WorklistItemType {
  Unknown = 0,
  PickOnly,
  PackOnly,
  ShipOnly,
  PickAndPack,
  PickPackAndShip,
  Receive,
  Putaway,
  ReceivePutaway,
  Relocate,
  Replenish,
  PhysicalItemCount,
  RecountItem
}

export enum TransferOrderStatus {
  Unknown = 0,
  Open,
  InProgress,
  Cancelled,
  Completed
}

export enum TransferOrderType {
  Unknown = 0,
  StockTransfer,
  Putaway,
  Picking,
  ReturnToStock,
  ScrapDisposal,
  CycleCountAdjustment
}

export enum OrderShipmentStatus {
  Unknown,
  OpenOrder,
  PartiallyPicked,
  FullyPicked,
  Packed,
  Shipped,
  Delivered,
  Cancelled
}

export enum DispatchOrderStatus {
  Unknown = 0,
  Open,
  InProgress,
  Shipped,
  Cancelled,
  Queued = 5,
  Processing = 6,
  Failed = 7,
  StepProcessed = 8
}

export enum DispatchOrderItemStatus {
  Unknown = 0,
  Pending,
  Picked,
  Packed,
  Shipped,
  Cancelled
}
export enum ProductTransactionType {
  Unknown = 0,
  ProductCreated,
  StockReceived,
  StockTransfered,
  StockReturned,
  StockAdjustment,
  StockDispatched,
  Miscellaneous,
  StockPacked,
  StockPicked,
  StockShipped
}
export enum WorklistSalesOrderTaskType {
  Unknown = 0,
  PickOnly,
  PackOnly,
  ShipOnly,
  PickAndPack,
  PickPackAndShip
}

export enum WorklistTransferOrderTaskType {
  Unknown = 0,
  PickOnly,
  PackOnly,
  ShipOnly,
  PickAndPack,
  PickPackAndShip
}

export enum WorklistPurchaseOrderTaskType {
  Unknown = 0,
  Receive,
  Putaway,
  ReceivePutaway
}

export enum WorklistMovementOrderTaskType {
  Unknown = 0,
  Putaway,
  PutawayTransfer
}
export enum MaterialTypes {
  Unknown = 0,
  Corrugated,
  Poly,
  PaddedEnvelope,
  WoodenCrate,
  MetalContainer,
  PlasticBox,
  ExtraLargePack
}

export enum DimensionUnits {
  Unknown = 0,
  CM,
  Inch,
  Feet
}

export enum WeightUnits {
  Unknown = 0,
  KG,
  Pound,
  Ounce,
  Ton
}
export enum ShipmentBoxType {
  Unknown = 0,
  CORRUGARED,
  POLY,
  PADDED_ENVELOPE,
  WOODEN_CRATE,
  METAL_CONTAINER,
  PLASTIC_BOX,
  EXTRA_LARGE_PACK
}
export enum WorkType {
  Unknown = 0,
  RelocateItems,
  ReplenishItems,
  PurchaseOrder,
  TransferOrder,
  InventoryCount,
  ReturnOrders,
  ReturnPurchaseOrder,
  ReturnTransferOrder
}

export enum OrderPriority {
  Unknown = 0,
  Low,
  Medium,
  High
}

export enum TransferOrderItemStatus {
  Unknown = 0,
  Pending,
  InProgress,
  Cancelled,
  Completed
}

export enum DiscountType {
  Unknown = 0,
  Amount,
  Percentage
}

export enum DiscountLevel {
  Unknown = 0,
  AtTransactionLevel,
  AtLineItemLevel
}

export enum ChargesType {
  ShippingAndHandlingFees = 1,
  CustomsAndImportDuties,
  PackagingCosts,
  InsuranceFee,
  RushOrderFees,
  InspectionAndQualityControlFees,
  StorageAndWarehousingFees,
  DocumentationFees,
  AdministrativeFee,
  EnvironmentalOrDisposalFees,
  Taxes,
  ServiceCharges,
  OtherCharges
}

export enum PurchaseReceiveOrderStatus {
  Unknown = 0,
  Received,
  Discrepancy,
  Cancelled
}

export enum TransferReceiveOrderStatus {
  Unknown = 0,
  Open = 1,
  InProgress = 2,
  Cancelled = 3,
  Queued = 4,
  Processing = 5,
  Failed = 6,
  StepProcessed = 7,
  Received = 8
}

export enum TrackInventoryOption {
  Unknown = 0,
  Standard,
  Batch,
  Serial
}

export enum DiscrepancyType {
  Unknown = 0,
  QuantityIssue,
  ItemIssue,
  ConditionIssue,
  PackagingIssue,
  MissingPartsOrComponents,
  SpecificationIssue,
  Other
}

export enum DiscrepancyReason {
  Unknown = 0,
  Shortage,
  Damage,
  ExcessQuantity,
  IncorrectItem,
  ExpiredProduct,
  QualityIssue,
  PackagingDamage,
  MissingPartsOrComponents,
  WrongSizeOrColor,
  UnauthorizedSubstitute
}

export enum MovementOrderRelocationType {
  Unknown = 0,
  WeekColor = 1,
  LicensePlate = 2,
  Product = 3,
  Location = 4,
  SerialBarcode = 5
}

export enum InvenotryAdjustmentType {
  Unknown = 0,
  Single,
  Multiple
}

export enum ProductStatus {
  Unknown = 0,
  Draft,
  Active,
  Inactive
}

export enum StockAdjustmentStatus {
  Unknown = 0,
  Draft,
  Approved,
  Rejected
}

export enum ProductEventSource {
  Unknown = 0,
  Product,
  StockAdjustment,
  PurchaseOrder,
  PurchaseReceiveOrder,
  PurchaseReturnOrder,
  TransferOrder,
  TransferDispatchOrder,
  TransferReceiveOrder,
  TransferReturnOrder,
  SalesOrder,
  SalesReturnOrder,
  InventoryCounting
}

export enum TransferScope {
  Unknown = 0,
  LicensePlate = 1,
  Product = 2
}

export enum TransferDispatchSource {
  Unknown = 0,
  SalesOrder,
  TransferOrder
}

export enum DiscrepancyStatus {
  Unknown = 0,
  Pending = 1,
  UnderReview = 2,
  Resolved = 3,
  Closed = 4,
  Rejected = 5
}

export enum ValidateInventoryUsageItemType {
  Unknown = 0,
  LicensePlate,
  Product,
  ProductSerial,
  WeekColor,
  Location
}

export enum MovementOrderStatus {
  Unknown = 0,
  Open,
  WorkInProgress,
  Queued,
  Processing,
  Completed,
  Cancelled,
  Failed
}

export enum MovementOrderType {
  Unknown = 0,
  Relocate,
  Replenish
}

export enum MovementOrderItemStatus {
  Unknown = 0,
  Pending,
  Picked,
  Relocated,
  Cancelled
}

export enum MovementOrderProcessType {
  Unknown = 0,
  Default,
  Quick
}

export enum TransferReceiveOrderProcessType {
  Unknown = 0,
  Default = 1,
  Quick = 2
}

export enum CarrierStatus {
  Unknown,
  Draft,
  Active,
  Inactive
}
export enum WorklistItemDurationAction {
  Unknown,
  EndDuration
}
export enum PrinterType {
  Unknown,
  ZebraLabel,
  ZebraTag,
  ZebraBoth
}
export enum CancelOperationType {
  Unknown,
  MovementOrder,
  TransferOrder,
  SalesOrder,
  InventoryCount
}

export enum NavigateToProcessPage {
  Unknown,
  PickProcess
}

export enum ProductSource {
  Unknown = 0,
  TPM,
  POS,
  Lister
}

export enum ProductListingStatus {
  Unknown = 0,
  NotListed,
  ReadyForListing,
  Queued,
  Processing,
  Failed,
  Listed,
  Sold
}

export enum Marketplace {
  Unknown = 0,
  eBay = 1,
  Goodwill_Finds = 2,
  Poshmark = 3,
  Shop_Goodwill = 4,
  Thrift_Spotter = 5
}
